export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
